<template>
    <div>
        <el-form-item label="Rotacja slajdów"
                      :error="errors.autorotate">
            <el-switch v-model="form.autorotate"/>
        </el-form-item>
        <el-form-item label="Czas pomiędzy automatyczną zmianą slajdu"
                      v-if="form.autorotate"
                      :error="errors.autorotate_interval">
            <el-input v-model="form.autorotate_interval" type="number"/>
        </el-form-item>
        <el-form-item label="">
            <div class="slides">
                <el-collapse class="formset__list">
                    <div v-for="slide, i in form.slides" class="formset__item">
                        <el-collapse-item :name="i">
                            <template slot="title">
                                <formset-header :label="`${slide.title_pl || 'Nowy slajd'}`"
                                                :errors="checkForErrors(errors.slides, [i])"
                                                :items.sync="form.slides"
                                                :index="i"/>
                            </template>
                            <div class="inline-form-group">
                                <el-form-item label="Tytuł"
                                              :error="errors.slides && errors.slides[i] && errors.slides[i]['title']">
                                    <el-input v-model="slide[addLanguageSuffix('title')]">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="Podtytuł"
                                              :error="errors.slides && errors.slides[i] && errors.slides[i]['subtitle']">
                                    <el-input v-model="slide[addLanguageSuffix('subtitle')]">
                                    </el-input>
                                </el-form-item>
                            </div>
                            <el-form-item label="Video"
                                          :error="errors.slides && errors.slides[i] && errors.slides[i]['video']">
                                <el-input v-model="slide.video"/>
                            </el-form-item>
                            <el-form-item label="Iframe"
                                          :error="errors.slides && errors.slides[i] && errors.slides[i]['iframe']">
                                <el-input type="textarea"
                                          v-model="slide.iframe"/>
                            </el-form-item>
                            <div class="inline-form-group">
                                <el-form-item label="Grafika"
                                              :error="errors.slides && errors.slides[i] && errors.slides[i]['image']">
                                    <image-input-component v-model="slide.image"/>
                                </el-form-item>
                                <el-form-item label="Kolor tekstu"
                                              :error="errors.slides && errors.slides[i] && errors.slides[i]['text_color']">
                                    <el-color-picker v-model="slide.text_color"/>
                                </el-form-item>
                            </div>
                            <el-collapse class="collapse">
                                <el-form-item label="">
                                    <el-collapse-item title="szczegóły lewego przycisku">
                                        <el-form-item label="Nazwa lewego przycisku"
                                                      :error="errors.slides && errors.slides[i]['left_button_title']">
                                            <el-input v-model="slide[addLanguageSuffix('left_button_title')]">
                                            </el-input>
                                        </el-form-item>
                                        <link-component v-model="slide.left_button_link"
                                                        :key="slide.left_button_link_key || slide.id + 'left'"
                                                        :errors="errors.slides && errors.slides[i]['left_button_link']">
                                        </link-component>
                                    </el-collapse-item>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-collapse-item title="szczegóły prawego przycisku">
                                        <el-form-item label="Nazwa prawego przycisku"
                                                      :error="errors.slides && errors.slides[i]['right_button_title']">
                                            <el-input v-model="slide[addLanguageSuffix('right_button_title')]">
                                            </el-input>
                                        </el-form-item>
                                        <link-component v-model="slide.right_button_link"
                                                        :key="slide.right_button_link_key || slide.id + 'right'"
                                                        :errors="errors.slides && errors.slides[i]['right_button_link']">
                                        </link-component>
                                    </el-collapse-item>
                                </el-form-item>
                            </el-collapse>
                        </el-collapse-item>
                    </div>
                </el-collapse>
                <el-button @click="addSection">Dodaj slajd</el-button>
                <div v-if="typeof errors.slides === 'string'" class="el-form-item__error">
                    {{ errors.slides }}
                </div>
            </div>
        </el-form-item>
    </div>
</template>
<script>
    import {Tag} from '@/api'
    import uniqueId from 'lodash.uniqueid'

    export default {
        props: ['form', 'errors'],
        methods: {
            addSection () {
                const blankObject = {
                    left_button_link_key: uniqueId('link_'),
                    right_button_link_key: uniqueId('link_'),
                }
                if (!Array.isArray(this.form.slides)) {
                    this.$emit('update:form', {
                        ...this.form,
                        slides: [
                            blankObject
                        ]
                    })
                } else {
                    this.form.slides.push(blankObject)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// SlidesWidget.vue?88211840